module.exports = __webpack_public_path__ + "img/6_28.4adc9454.png";